import { render, staticRenderFns } from "./Gf.vue?vue&type=template&id=582113c4&"
import script from "./Gf.vue?vue&type=script&lang=js&"
export * from "./Gf.vue?vue&type=script&lang=js&"
import style0 from "./Gf.vue?vue&type=style&index=0&id=582113c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports